import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { options } from "./utilities";

i18n.use(LanguageDetector).use(initReactI18next).init(options);

export default i18n;
